import { render, staticRenderFns } from "./Mainlayout.vue?vue&type=template&id=20ca3759"
import script from "./Mainlayout.vue?vue&type=script&lang=js"
export * from "./Mainlayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports